/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBudgetHistoryBackfill extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBudgetHistoryBackfill");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBudgetHistoryBackfill.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBudgetHistoryBackfill>): BackgroundJobPayloadForPeriodicBudgetHistoryBackfill {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBudgetHistoryBackfill(), model);
        BackgroundJobPayloadForPeriodicBudgetHistoryBackfill.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBudgetHistoryBackfill>): BackgroundJobPayloadForPeriodicBudgetHistoryBackfill {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBudgetHistoryBackfill.newInstance(<BackgroundJobPayloadForPeriodicBudgetHistoryBackfill> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBudgetHistoryBackfill) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBudgetHistoryBackfill.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBudgetHistoryBackfill): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBudgetHistoryBackfill.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
